import React from 'react';
import './App.css';
import Raffle from './Views/Raffle/Raffle';
import { Container, createMuiTheme, CssBaseline, ThemeProvider } from '@material-ui/core';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import Status from './Views/Status/Status';
import firebase from 'firebase';
import { firebaseConfig } from './config/firebaseConfig';
import { FirebaseDatabaseNode, FirebaseDatabaseProvider } from '@react-firebase/database';
import Entries from './Views/Entries/Entries';

const theme = createMuiTheme({
  overrides: {
    MuiCssBaseline: {
      '@global': {
        body: {
          backgroundColor: 'transparent',
        },
      },
    },
  },
});

const App: React.FC<Record<string, unknown>> = () => (
  <>
    <FirebaseDatabaseProvider firebase={firebase} {...firebaseConfig}>
      <FirebaseDatabaseNode
        path='raffle/'
        // limitToFirst={10}
        // limitToFirst={this.state.limit}
        // orderByKey
        orderByValue={'created_on'}
      >
        {(d) => {
          let publicTickets = 0;
          let memberTickets = 0;
          if (d.value) {
            Object.keys(d.value.brisBricks202012PublicRaffle.transactions).forEach((v) => {
              publicTickets =
                publicTickets + d.value.brisBricks202012PublicRaffle.transactions[v].tickets;
            });
            Object.keys(d.value.brisBricks202012MemberRaffle.transactions).forEach((v) => {
              memberTickets =
                memberTickets + d.value.brisBricks202012MemberRaffle.transactions[v].tickets;
            });
          }
          return (
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <Container>
                <Router>
                  <Switch>
                    <Route path={`/allRaffleStatus`}>
                      <Status memberTickets={memberTickets} publicTickets={publicTickets} />
                    </Route>
                    <Route path={`/allMyEntriesTogether`}>
                      <Entries allEntries={d.value} />
                    </Route>
                    <Route path={`/raffle/:raffleId`}>
                      <Raffle memberTickets={memberTickets} publicTickets={publicTickets} />
                    </Route>
                    <Route>
                      <Redirect to='/raffle/brisBricks202012PublicRaffle' />
                    </Route>
                  </Switch>
                </Router>
              </Container>
            </ThemeProvider>
          );
        }}
      </FirebaseDatabaseNode>
    </FirebaseDatabaseProvider>
  </>
);

export default App;
